import { Component } from '@angular/core';
@Component({
  selector: 'not-found',
  template: '<h3>Error 404: Not found</h3>'
})

export class NotFound404Page { }
